module.exports = __webpack_public_path__ + "static/media/viewcolumnmappings.a46f578d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/viewcolumnmappings.png
// module id = 1861
// module chunks = 193